import Modal from "common/Modal/Modal";
import { SuccessConfetti } from "common/Icons/Icons";
import styled, { useTheme } from "styled-components";
import NewLookSuccessIllustration from "features/portfolio/CreateAccount/NewLook/NewLookSuccessIllustration";
import Text from "common/Typography/Text";
import { typography } from "@shared/common/Themes/typography";
import Button from "common/Buttons/Button";
import { useUser } from "@shared/utils/hooks/misc";
import { getTelegramWebAppPath } from "utils/routes";
import { PORTFOLIO_ACCOUNTS_PATH } from "common/constants";
import { LanguageNameSpaces } from "@shared/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface TgQuickConnectSuccessModalProps {
  isOpen: boolean;
  closeModal: () => void;
}

const TgQuickConnectSuccessModal = ({
  isOpen,
  closeModal,
}: TgQuickConnectSuccessModalProps) => {
  const { user } = useUser();
  const { isNewLook } = useTheme();
  const { t } = useTypedTranslation(LanguageNameSpaces.PORTFOLIO);

  const onBackToTelegramClick = () => {
    if (user?.bot_url) {
      window.open(
        getTelegramWebAppPath(user?.bot_url, PORTFOLIO_ACCOUNTS_PATH),
        "_blank"
      );
    }
  };

  const description = t("quick_connect.success_description");

  if (isNewLook) {
    return (
      <Modal open={isOpen} onCancel={closeModal} footer={false} width={440}>
        <NewLookWrapper>
          <NewLookSuccessIllustration width={128} height={96} />
          <NewLookTitle>{t("quick_connect.accounts_created")}</NewLookTitle>
          <NewLookText>{description}</NewLookText>
          <Button
            type="primary"
            $size="l"
            onClick={onBackToTelegramClick}
            style={{ width: "100%" }}
          >
            {t("quick_connect.back_to_telegram")}
          </Button>
        </NewLookWrapper>
      </Modal>
    );
  }

  return (
    <Modal open={isOpen} onCancel={closeModal} footer={false}>
      <Wrapper>
        <SuccessConfetti
          style={{ width: 100, height: "auto", marginBottom: 16 }}
        />
        <Text
          $weight={typography.fontWeights.MEDIUM}
          $size="L"
          style={{ marginBottom: 4 }}
        >
          {t("quick_connect.accounts_created")}
        </Text>
        <Text type="secondary" style={{ marginBottom: 16 }}>
          {description}
        </Text>
        <Button type="link" onClick={onBackToTelegramClick}>
          {t("quick_connect.back_to_telegram")}
        </Button>
      </Wrapper>
    </Modal>
  );
};

export default TgQuickConnectSuccessModal;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
const NewLookWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding-top: 8px;
  text-align: center;
`;
const NewLookTitle = styled.div`
  margin-top: 8px;
  color: ${(p) => p.theme.colors.titleColor};
  font-size: 18px;
  line-height: 26px;
  font-weight: 520;
`;
const NewLookText = styled.p`
  margin: 0 0 12px;
  color: ${(p) => p.theme.colors.secondaryText};
  font-size: 14px;
  line-height: 21px;
`;
